import * as _ from 'lodash';
import * as React from 'react';
import * as cookie from 'react-cookie';
import { generateInnerHtml } from 'shared-react';

import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import FormDialogFooter from 'login-components/Common/Form/FormDialog/FormDialogFooter';
import FormTitle from 'login-components/Common/Form/FormTitle/FormTitle';
import './TermsOfServiceViewer.scss';

interface TermsOfServiceViewerProps {
  htmlText: string | null;
  disableSubmit?: boolean;
  error?: string;
  onSubmit?: (e: React.FormEvent<any>) => void;
  action: string;
  queryParams?: {
    loanType?: string;
    applicationTemplateId?: string;
    displayLink?: string;
    referrerId?: string;
    app_source?: string;
  };
  showAgreeText?: boolean;
}

class TermsOfServiceViewer extends React.Component<TermsOfServiceViewerProps, {}> {
  render() {
    const agreeText = 'Agree';
    const csrfToken = cookie.load('XSRF-TOKEN');
    const { showAgreeText = true, action, onSubmit, queryParams, htmlText, disableSubmit, error } = this.props;

    return (
      <form className="TermsOfServiceViewer" action={action} method="post" onSubmit={onSubmit}>
        <input type="hidden" name="_csrf" value={csrfToken} />
        {_.map(queryParams || {}, (value: string, key: string) => {
          return (
            <input
              type="hidden"
              name={key === 'displayLink' ? 'applicationTemplateDisplayLink' : key}
              value={value}
              key={key}
            />
          );
        })}
        <div className="TermsOfServiceViewer-body">
          <div className="TermsOfServiceViewer-contentWrapper">
            {showAgreeText && (
              <div className="TermsOfServiceViewer-agreementTitle">
                <FormTitle text={`By clicking ${agreeText}, you agree to the following Terms and Conditions.`} />
              </div>
            )}
            <div
              className="TermsOfServiceViewer-termsText BrandLinks"
              // We allow img here in addition to other tags because we embed images in TOS
              {...generateInnerHtml(htmlText, ['img', 'span'], {
                div: ['TermsOfService'],
                li: ['TermsOfService-listHeader'],
                span: ['Uppercase'],
              })}
            />
          </div>
        </div>
        <div className="TermsOfServiceViewer-normalizeWidthWrapper">
          {error && (
            <div className="TermsOfServiceViewer-errorWrapper">
              <ErrorMessage errorText={error} />
            </div>
          )}
          {onSubmit && (
            <div className="TermsOfServiceViewer-footerWrapper">
              <FormDialogFooter>
                <PrimaryButton disabled={disableSubmit} text={agreeText} buttonId="it-TermsSubmitButton" />
              </FormDialogFooter>
            </div>
          )}
        </div>
      </form>
    );
  }
}

export default TermsOfServiceViewer;
